import CollaboratorsData from '../Data/CollaboratorsData';

const Collaborators = ({width,dimensions}) => {

	function Collaboratorsloog() {
		let arr = [];
		for(let i = 0; i < CollaboratorsData.length; i++){
			arr.push(
				<div key={i} style={{margin:14,textAlign:'center'}}>
					{/*<div style={{height:190,width:190,overflow:'hidden',borderRadius:180,backgroundImage:'radial-gradient(rgba(0,0,0,0),rgba(0,0,0,0.1))'}} className='absolute'></div>*/}
					<div className='flexCenter' style={{height:190,width:190,overflow:'hidden',borderRadius:180,background:'rgb(246,246,246)'}}>
						<img src={CollaboratorsData[i].thumbnail} alt='artist' style={{height:'100%'}} />
					</div>
					<div className='bold' style={{marginTop:10}}>{CollaboratorsData[i].name}</div>
				</div>
			)
		}
		return <div className='flexCenter' style={{width:width,flexWrap:'wrap'}}>{arr}</div>
	}
	return(
		<div>
			<div className='heading bold' style={{marginBottom:20}}>Collaborators</div>
			{Collaboratorsloog()}
		</div>
	)
}

export default Collaborators;